<template>
  <div class="modal-wrapper">
    <!-- Button trigger modal -->
    <span
      class="clickable"
      data-toggle="modal"
      data-target="#prefixModal"
      @click="resetSelectedIPs"
      >Select here</span
    >

    <!-- Modal -->
    <div
      class="modal fade"
      id="prefixModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="prefixModalTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalTitle">
              List of offending prefixes
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body" v-if="noAccount">
            <empty-state
              title="Nothing to track here"
              description="Before we can track your suspicious traffic, we’ll first need to know what is applicable to your network."
            ></empty-state>
            <link-account class="mt-48"></link-account>
          </div>
          <div class="modal-body" v-else-if="noASN">
            <empty-state
              title="No Autonomous System (AS) is associated to this member account."
              description="Currently only AS holders can track suspicious traffic coming from their network."
            ></empty-state>
          </div>
          <div class="modal-body" v-else-if="noPrefixData">
            <empty-state
              title="Nothing to select here"
              description="Our honeynet sensors have not seen suspicious traffic coming from your network."
            ></empty-state>
          </div>
          <template v-else>
            <div class="modal-body">
              <p>
                Select the list of offending IP addresses that you would like to
                receive further information on
              </p>
              <MonthSelection class="month-selection" />
              <div class="border-wrapper">
                <vueCustomScrollbar style="padding-right: 10px">
                  <ActivityTable :selectable="true" class="activity-table" />
                </vueCustomScrollbar>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-outline-primary"
                data-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                class="btn btn-primary"
                @click="confirm"
                data-dismiss="modal"
                :disabled="!selectedIPs.length"
              >
                Confirm IP addresses
              </button>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vueCustomScrollbar from 'vue-custom-scrollbar';
import MonthSelection from '../MonthSelection';
import ActivityTable from '../ActivityTable';
import mixin from '../../utils/helpMixin';
import EmptyState from '../ui/EmptyState.vue';
import LinkAccount from '../ui/LinkAccount.vue';
import { mapGetters } from 'vuex';

export default {
  mixins: [mixin],
  components: {
    ActivityTable,
    MonthSelection,
    vueCustomScrollbar,
    EmptyState,
    LinkAccount
  },
  methods: {
    confirm() {
      this.setConfirmSelected();
    },
    resetSelectedIPs() {
      if (this.confirmedSelectedIPs) {
        this.setSelectedIPs(this.confirmedSelectedIPs);
      } else {
        this.setSelectedIPs([]);
      }
    }
  },
  computed: {
    ...mapGetters('dataStore', ['noAccount', 'noASN']),
    noPrefixData() {
      return !this.selectedASN?.prefix?.data?.length;
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-wrapper {
  display: inline;

  & ::v-deep .activity .search-bar--mobile {
    width: calc(100vw - 95px);
  }
}
.modal-dialog {
  max-width: calc(100vw - 20px) !important;
}
.clickable {
  color: $apnic-blue;
  cursor: pointer;
}
.activity-table {
  height: 400px;
}
.modal-content {
  margin: 0 auto;
  width: auto;
}
.modal-body {
  p {
    margin: 8px 0 24px;
  }

  .month-selection {
    margin-bottom: 24px;
  }
}
.modal-footer {
  display: flex;
  justify-content: space-between;

  .btn-primary {
    line-height: 16px;
  }
}
.border-wrapper {
  padding: 5px;
  border: 1px solid #e6e6e6;
}

@media screen and (max-width: 450px) {
  .modal {
    &-header,
    &-body,
    &-footer {
      padding: 8px;
    }

    &-body {
      p {
        margin-bottom: 8px;
      }
      .month-selection {
        margin-bottom: 8px;
      }
    }
  }

  .border-wrapper {
    padding: 1px;
  }

  .activity-table {
    height: 280px;
  }
}
</style>
